import { render, staticRenderFns } from "./CollapsibleVisualFlow.vue?vue&type=template&id=4c72cc32"
import script from "./CollapsibleVisualFlow.vue?vue&type=script&lang=js"
export * from "./CollapsibleVisualFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports